import { ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import { Access } from "../../interfaces/auth.interface";
import { useTheme } from '@mui/material/styles';
import menuIcons from './menuIcons';

interface UserMenuInterface {
    menuSelected: Access | null;
    subMenuSelected: Access | null;
    onClick: (itemSelected: Access) => void
}

const UserSubMenu = ({ menuSelected, subMenuSelected, onClick }: UserMenuInterface) => {
    const theme = useTheme();
    const hiddenMenuItems = ["Beneficios", "Administradores", "Documentos", "Áreas"];

    return (
        <>
            {menuSelected?.children
                ?.filter((group: Access) => !hiddenMenuItems.includes(group.Name))
                .map((group) => {
                    const MenuIcon = menuIcons[group.Name];
                    const isSelected = group.urlPath === subMenuSelected?.urlPath;

                    return (
                        <ListItem
                            key={group.Name}
                            disablePadding
                            sx={{
                                display: 'block',
                                padding: 0,
                                ...(isSelected && {
                                    backgroundColor: theme.s10palette.S10Greygrey50,
                                    borderRadius: "0.25rem"
                                })
                            }}
                        >
                            <ListItemButton
                                disableTouchRipple
                                sx={{
                                    padding: "0.5rem",
                                    height: "2.625rem",
                                    borderRadius: "0.25rem",
                                    '&:hover': {
                                        backgroundColor: theme.s10palette.S10Greygrey50,
                                    },
                                    '&:hover .MuiListItemIcon-root': {
                                        color: 'black',
                                    },
                                    '&:hover .MuiTypography-root': {
                                        color: 'black',
                                    },
                                    ...(isSelected && {
                                        backgroundColor: theme.s10palette.S10Greygrey50,
                                    })
                                }}
                                onClick={() => onClick(group)}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        marginRight: '0.5rem',
                                        color: isSelected ? 'black' : theme.s10palette.S10Greygrey100,
                                    }}
                                >
                                    {MenuIcon ? <MenuIcon /> : "¿?"}
                                </ListItemIcon>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        color: isSelected ? 'black' : theme.s10palette.S10Greygrey100,
                                        textWrap: "wrap",
                                    }}
                                >
                                    {group.Name}
                                </Typography>
                            </ListItemButton>
                        </ListItem>
                    );
                })}
        </>
    );
};

export default UserSubMenu;